import { groq } from '#imports';

export function getQuery({ searchQuery }) {
  const query = groq`*[_type == "news" && !(_id in path('drafts.**'))]
    | score(title match "${searchQuery}")
    | order(publishedAt desc) {
      _score,
      _id,
      slug,
      title,
      publishedAt,
    }
    [_score > 0]
  `;
  return { query, params: { searchQuery } };
}
